// defaultFormDataEntreprise.js
// Valeurs initiales pour la création d'entreprise et informations personnelles

const defaultFormDataEntreprise = {
  // 1. Informations sur l’entreprise
  raisonSociale: "",
  formeJuridique: "",
  adresseSiege: "",
  activitePrincipale: "",
  capitalSocial: "",
  nombreAssocies: "",

  // 2. Projet d’entreprise
  objetEntreprise: "",
  etudeMarche: "",
  planFinancier: "",

  // 3. Financement et investissements
  apportPersonnel: "",
  besoinFinancementExterne: false,
  montantFinancementSouhaite: "",
  sourceFinancement: "",

  // 4. Local et équipements
  locauxNecessaires: false,
  natureLocal: "",
  materielRequis: "",

  // 5. Régime fiscal et social
  optionFiscale: "",
  nombreEmployesPrevus: "",
  affiliationCnasCasnos: false,

  // 6. Démarches et formalités administratives
  besoinAccompagnement: false,
  disponibiliteDocuments: "",

  // Indique qu'il s'agit bien d'une entreprise
  isEntreprise: true,

  // Informations personnelles
  nom: "",
  prenom: "",
  dateNaissance: "",
  adresse: "",
  telephone: "",
  email: "",
  passport: "",
  situationProfessionnelle: "",
};

export default defaultFormDataEntreprise;
